import React, { memo, useEffect, useState } from 'react';
import styled from 'styled-components';
import { Title1 } from '../../../../components/Typography';
import CategoriesBar from './components/CategoriesBar';
import Category from './components/Category';
import MenuRewardsContainer from '../../../MenuRewards/MenuRewardsContainer';
import appConfig from '../../../../../app-config';
import OrderStatusContainer from '../../../OrderStatus/OrderStatusContainer';
import CartMenuSidebarContainer from '../../../CartMenuSidebar/CartMenuSidebarContainer';
import MenuSearch from '../../../ParentChildRefactor/components/MenuSearch';
import GlobalSearchContainer from '../GlobalSearchMenu/GlobalSearchContainer';
import { connectSearchBox } from 'react-instantsearch-dom';

const ProductCartWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 264px;
  grid-gap: 32px;
  margin: 0 5%;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 786px) {
    margin-top: -50px;
    display: block;
    margin-top: 12px;
  }
`;

const RewardWrapper = styled.div``;

const RewardTitleWrapper = styled(Title1)`

  // text-transform: ${(props) => props.theme.rewardTitleTextTransform};
  letter-spacing: 0.04px;
  margin-top: 32px;
  font-weight: 600;
  // width: max-content;
  width: fit-content;

  :after {
    content: '';
    display: block;
    width: calc(100% + 2px);
    padding-top: 2px;
    border-bottom: ${(props) =>
      props.categoriesBarSelectedBorderColorWidth} solid
      ${(props) =>
        appConfig.styleConfig.separatorColor
          ? appConfig.styleConfig.separatorColor
          : props.theme.primaryColor};
  }
`;

const Menu = ({
  categories,
  products,
  combos,
  handleProductPreviewClick,
  handleComboPreviewClick,
  dontSelectMyOrders,
  orderSettingReducer,
  searchProduct,
  currentRefinement,
  refine,
}) => {
  const [modifiedCategories, setModifiedCategories] = useState([]);

  useEffect(() => {
    if (categories.length > 0) {
      const productIds = products.map((product) => product.product_id);
      const modifiedCats = categories.reduce((acc, category) => {
        if (category.name === 'My Orders' || category.category_id === 998) {
          acc.push(category);
        } else {
          if (category.products.length > 0) {
            if (
              category.products.some((product) =>
                productIds.includes(product.product_id)
              )
            ) {
              acc.push(category);
            }
          } else if (category.sub_categories.length > 0) {
            const subCategories = [];
            category.sub_categories.forEach((subCat) => {
              if (
                subCat.products.some((product) =>
                  productIds.includes(product.product_id)
                )
              ) {
                subCategories.push(subCat);
              }
            });
            if (subCategories.length > 0) {
              acc.push({ ...category, sub_categories: subCategories });
            }
          }
        }
        return acc;
      }, []);
      setModifiedCategories(modifiedCats);
    }
  }, [categories]);
  return (
    <div>
      {(appConfig.isParentChildClient && !appConfig.isGlobalSearchEnabled) ||
      appConfig.appSource == 'thebottledrive' ? (
        <MenuSearch
          orderSettingReducer={orderSettingReducer}
          searchProduct={searchProduct}
        />
      ) : null}
      {currentRefinement &&
      currentRefinement !== '' &&
      appConfig.isGlobalSearchEnabled ? (
        <GlobalSearchContainer
          refine={refine}
          handleComboPreviewClick={handleComboPreviewClick}
        />
      ) : (
        <div>
          <CategoriesBar
            id='Menu-CategoriesBar'
            categories={modifiedCategories}
            dontSelectMyOrders={dontSelectMyOrders}
          />

          <ProductCartWrapper>
            <div>
              {appConfig.isOrderStatusEnabled && <OrderStatusContainer />}
              {!appConfig.isLoyaltyEnabled ? null : (
                <RewardWrapper>
                  <RewardTitleWrapper>
                    <span id='MenuB-AppTitle'>{appConfig.appTitle}</span>
                    <span id='MenuB-Rewards' style={{ marginLeft: '10px' }}>
                      {appConfig.appSource === 'iQ' ? 'LOYALTY' : 'Rewards'}
                    </span>
                  </RewardTitleWrapper>
                  <MenuRewardsContainer />
                </RewardWrapper>
              )}

              {modifiedCategories.map((category) => (
                <Category
                  id='MenuB-Category'
                  category={category}
                  products={products}
                  combos={combos}
                  handleComboPreviewClick={handleComboPreviewClick}
                  handleProductPreviewClick={handleProductPreviewClick}
                  key={category.category_id}
                />
              ))}
            </div>

            <CartMenuSidebarContainer />
          </ProductCartWrapper>
        </div>
      )}
    </div>
  );
};

export default appConfig.isGlobalSearchEnabled
  ? memo(connectSearchBox(Menu))
  : memo(Menu);
